import styled from 'styled-components'
import { colors } from 'themes'

import { TextRadioForm as TextRadioFormOriginal } from 'components/RadioForm'
import { CrossButtonDark } from 'components/Buttons/CrossButton'
import ConfirmButton from 'components/Buttons/ConfirmButton'
import TextAreaOriginal from 'components/Inputs/TextArea'

export const FeedbackContainer = styled.div`
  height: 100%;
  position: relative;
  
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  
  background-color: ${colors.default.background};
  padding: 45px 25px 0;
  
  .reason { 
  	color: #346C84;
  	margin-bottom: 16px;
  }
`

export const CrossButton = styled(CrossButtonDark)`
	top: 45px;
`

export const SubHeader = styled.div`
  margin: 2px 0 0;
  font-weight: 700;
  font-size: 14px;
  color: ${colors.default.text};
`

export const HorizontalSeparator = styled.div`
  border-top: 1px solid ${colors.default.underline};
  margin: 16px -25px 25px;
`

export const SubmitButton = styled(ConfirmButton)`
	border-radius: 30px;
	padding: 14px 30px;
	margin: 35px 0 40px;

	@media (max-height: 650px) {
		margin: 15px 0;
	}

  .disabled {
    pointer-events: none;
    background-color: gray;
  }
`

export const TextRadioForm = styled(TextRadioFormOriginal)`
	margin-bottom: 70px;
	@media (max-height: 550px) {
		margin-bottom: 10px;
	}
`

export const TextArea = styled(TextAreaOriginal)`
	flex: 1;
`
